import { calculateShoppingCartTotal, getShopItemPrice } from './shopItemsAndCart'
import { catalogIdForShopItem } from './catalogId'

export default function sendEvent(analyticsEvent) {
  if (analyticsEvent && analyticsEvent.name) {
    sendAnalyticsEvent(analyticsEvent.name, analyticsEvent.parameters)
  }
}

export function sendAnalyticsEvent(name, parameters) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, parameters || {})
  }
}

export function buildAddToCartEvent(shopItem) {
  const gaItems = [ toGAItem(shopItem, 1) ]

  return {
    name: 'add_to_cart',
    parameters: {
      currency: shopItem.price.currency,
      value: calculateEventValue(gaItems),
      items: gaItems
    }
  }
}

export function buildRemoveFromCartEvent(shopItem) {
  const gaItems = [ toGAItem(shopItem, 1) ]

  return {
    name: 'remove_from_cart',
    parameters: {
      currency: shopItem.price.currency,
      value: calculateEventValue(gaItems),
      items: gaItems
    }
  }
}

export function buildBeginCheckoutEvent(shoppingCart, shopItems) {
  const itemsInCart = Object.keys(shoppingCart).map(type => shopItems.find(i => i.itemType.itemType === type))
  const cartTotalPrice = calculateShoppingCartTotal(shopItems, shoppingCart)

  const gaItems = itemsInCart.map(i => toGAItem(i, shoppingCart[i.itemType.itemType]))

  return {
    name: 'begin_checkout',
    parameters: {
      currency: cartTotalPrice.currency,
      value: calculateEventValue(gaItems),
      items: gaItems
    }
  }
}

function toGAItem(shopItem, quantity) {
  const shopItemPrice = getShopItemPrice(shopItem)
  return {
    item_id: catalogIdForShopItem(shopItem),
    item_name: shopItem.name,
    price: shopItemPrice ? (shopItemPrice.priceCents / 100) : 0,
    quantity: quantity,
  }
}

function calculateEventValue(gaItems) {
  let value = 0
  for (const gaItem of gaItems) {
    value += gaItem.price * gaItem.quantity
  }

  return value
}
